import React from 'react';
import { ChevronRight, Zap } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-87">
      {/* Background Effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-gaming-purple/20 blur-[120px] rounded-full pointer-events-none" data-id="element-88" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-gaming-cyan/10 blur-[100px] rounded-full pointer-events-none" data-id="element-89" />

      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-90">
        {/* Text Content */}
        <div className="flex flex-col space-y-8 text-center lg:text-left" data-id="element-91">
          <div className="inline-flex items-center space-x-2 bg-gaming-card border border-gaming-purple/30 px-4 py-2 rounded-full w-fit mx-auto lg:mx-0 box-glow-purple" data-id="element-92">
            <Zap className="w-4 h-4 text-gaming-cyan-light" data-id="element-93" />
            <span className="text-sm font-medium text-gaming-cyan-light uppercase tracking-wider" data-id="element-94">
              Sistema Probado
            </span>
          </div>

          <h1 className="font-orbitron text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight text-white" data-id="element-95">
            Plan de Acción Para Pasar de Jugador a Streamer: <br data-id="element-96" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gaming-purple-light to-gaming-cyan-light text-glow-purple" data-id="element-97">
              El Sistema Táctico para tus Primeros $500/mes
            </span>
          </h1>

          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-98">
            Deja de hablarle al vacío y convierte tu pasión en un negocio real
            sin gastar un solo dólar en equipo profesional.
          </p>

          <div className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6 pt-4 justify-center lg:justify-start" data-id="element-99">
            <a href="#offer-price" className="group relative inline-flex items-center justify-center px-8 py-4 font-orbitron font-bold text-white uppercase tracking-widest bg-gaming-purple hover:bg-gaming-purple-light transition-all duration-300 rounded-sm box-glow-purple-strong hover:scale-105" data-id="element-100">
              <span data-id="element-101">¡Sí, quiero empezar mi imperio ahora!</span>
              <ChevronRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-102" />
            </a>
          </div>
          <p className="text-sm text-gray-400 font-medium" data-id="element-103">
            ⚡ Acceso inmediato tras la compra.
          </p>
        </div>

        {/* Product Image */}
        <div className="relative mx-auto w-full max-w-lg lg:max-w-full" data-id="element-104">
          <div className="absolute inset-0 bg-gaming-purple/30 blur-[60px] rounded-full" data-id="element-105" />
          <div className="relative rounded-xl border border-gaming-purple/20 bg-gaming-card/50 p-2 backdrop-blur-sm box-glow-purple" data-id="element-106">
            <img src="https://cdn.magicpatterns.com/uploads/3qsBFwgGGPnJh14F21eMfY/heylloyd-image-1773457670579.png" alt="Plan de Acción Para Pasar de Jugador a Streamer" className="w-full h-auto rounded-lg object-cover shadow-2xl" data-id="element-107" />
            {/* Decorative corners */}
            <div className="absolute -top-1 -left-1 w-4 h-4 border-t-2 border-l-2 border-gaming-cyan" data-id="element-108" />
            <div className="absolute -top-1 -right-1 w-4 h-4 border-t-2 border-r-2 border-gaming-cyan" data-id="element-109" />
            <div className="absolute -bottom-1 -left-1 w-4 h-4 border-b-2 border-l-2 border-gaming-cyan" data-id="element-110" />
            <div className="absolute -bottom-1 -right-1 w-4 h-4 border-b-2 border-r-2 border-gaming-cyan" data-id="element-111" />
          </div>
        </div>
      </div>
    </section>;
}